import { setItem } from '@/utils/StorageManager'
import { integer } from 'vuelidate/lib/validators'

export default {
  UPDATE_CURRENT_CHANNEL(state, payload) {
    state.activeBlock = payload

    if (payload.blockLibrary) {
      state.collapse[payload.collapse] = !state.collapse[payload.collapse]
      return
    }

    Object.entries(state.collapse).forEach(([key]) => {
      if (payload.collapse != key) {
        state.collapse[key] = false
        return
      }

      if (payload.indexChannel == state.activeBlock.indexChannel) {
        state.collapse[key] = true
        return
      }

      state.collapse[key] = !state.collapse[payload.collapse]
    })

    if (
      payload.collapse == state.activeBlock.cardName &&
      !!state.collapse[payload.collapse] &&
      payload.indexChannel !== state.activeBlock.indexChannel
    ) {
      state.activeBlock.cardName = null
    }
  },

  UPDATE_MAIN_CAMPAIGN(state, payload) {
    state.mainCampaign = payload
  },

  UPDATE_REMOVE_CHANNEL(state, indice) {
    state.mainCampaign.values.splice(indice, 1)
  },

  UPDATE_ADD_CHANNEL(state, payload) {
    state.mainCampaign.values ? state.mainCampaign.values.push(payload) : (state.mainCampaign.values = [payload])
  },

  UPDATE_AUDIENCE_TARGET(state, targetChannel) {
    state.mainCampaign.values[targetChannel.indice].audience.segments = targetChannel.segments
    state.mainCampaign.values[targetChannel.indice].audience.override = targetChannel.override
    state.mainCampaign.values[targetChannel.indice].audience.targetAudienceType = targetChannel.targetAudienceType
    state.mainCampaign.values[targetChannel.indice].audience.totalContacts = targetChannel.totalContacts
  },

  UPDATE_SMS_CONTENT(state, targetContent) {
    for (var item in targetContent.content) {
      state.mainCampaign.values[targetContent.indice].content[item] = targetContent.content[item]
    }
  },

  UPDATE_EMAIL_CONTENT(state, targetContent) {
    for (var item in targetContent.content) {
      state.mainCampaign.values[targetContent.indice].content[item] = targetContent.content[item]
    }
  },

  UPDATE_TIME(state, targetChannel) {
    state.mainCampaign.values[targetChannel.indice].time = targetChannel.time
  },

  UPDATE_INCATIVE_FLOW(state, stateFlow) {
    state.inactiveFlow = stateFlow
  },

  UPDATE_CAMPAIGN_NAME(state, name) {
    state.mainCampaign.name = name
  },

  UPDATE_CAMPAIGN_ID(state, campaignId) {
    state.mainCampaign.campaignId = campaignId.id
    state.mainCampaign.organizationUserId = campaignId.organizationUserId
  },

  UPDATE_COLLAPSE(state, block) {
    state.collapse[block] = !state.collapse[block]
  },

  UPDATE_AUXILIARES(state, aux) {
    for (var item in aux) {
      state.auxiliares[item] = aux[item]
    }
  },

  UPDATE_EMAIL_TEMPLATE(state, payload) {
    state.mainCampaign.values[payload.indexChannel].content.contentType = parseInt(payload.template.contentType)
    state.mainCampaign.values[payload.indexChannel].content.templateId = payload.template.id
    state.mainCampaign.values[payload.indexChannel].content.templateName = payload.template.name
    state.mainCampaign.values[payload.indexChannel].content.htmlFileUri = payload.template.htmlFileUri
    state.mainCampaign.values[payload.indexChannel].content.thumbnailUri = payload.template.thumbnailUri
    state.mainCampaign.values[payload.indexChannel].content.emailSimpleText = payload.template.emailSimpleText
  },

  UPDATE_ROCKET(state, statusCampaign) {
    state.mainCampaign.status = statusCampaign
  },

  START_AUTOSAVE(state, autoSave) {
    state.autoSave = autoSave
  },

  STOP_AUTOSAVE(state) {
    if (state.autoSave) clearInterval(state.autoSave)
    // state.autoSave = null
  },
}
